import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {contentPresetView_template} from "../components/templates/contentPresetView_template";

declare var ko: any;
declare var page: any;

export class content_preset_view extends vnModule_knockoutJS {

    protected contentPresetView: contentPresetView_template;
    protected XHRHdl: XMLHttpRequestHandler;

    buildContent(): Array<Element> {
        this.contentPresetView = new contentPresetView_template("content_preset_view_template", this.viewModel, this);
        return [this.contentPresetView.build()];
    }

    protected getModuleName(): string {
        return "content_preset_view";
    }

    fillPage() {
        this.getContentPresetDataForView()
    }

    private getContentPresetDataForView() {

        this.loadingIn(this.contentPresetView.builtTemplate);

        let url : string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/contentpreset/get/view/' + this.getVnAppZone().app.params.id + '/';
        let request_parameters : Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(url, request_parameters, this);
        this.XHRHdl.onReadyStateFunction = this.onGetContentPresetDataForView;
        this.XHRHdl.execute();
    }

    private onGetContentPresetDataForView(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                let contentpreset = responseParsed.data
                obj.contentPresetView.setContentPresetData(contentpreset);

            });

            obj.loadingOut(obj.contentPresetView.builtTemplate);
        }
    }

    protected onClickEditContentPreset(id){
        let brandId = this.getVnAppZone().app.params.idBrand
        page("/brand/" + brandId + "/config/content-presets/edit/" + id + '/')
    }

    protected onClickCancel(){
        let brandId = this.getVnAppZone().app.params.idBrand
        page.redirect("/brand/" + brandId + "/config/content-presets/")
    }

}


// WEBPACK FOOTER //
// ./js/modules/content_preset_view.ts